/**
 * API Configuration Utility
 * Auto-detects the backend URL based on the current domain.
 * Falls back to environment variable for local development.
 */

// Strip trailing slash so `${API}/route` never produces a `//` in the path.
const stripTrailing = (s) => (s || '').replace(/\/+$/, '');

// Get the backend URL - auto-detect from current domain or use env var
const getBackendUrl = () => {
  // In production, use the current domain
  if (typeof window !== 'undefined' && window.location.origin) {
    const origin = window.location.origin;

    // If we're on localhost, use the environment variable
    if (origin.includes('localhost') || origin.includes('127.0.0.1')) {
      return stripTrailing(process.env.REACT_APP_BACKEND_URL || origin);
    }

    // Otherwise, use the current origin (works for any deployed domain)
    return stripTrailing(origin);
  }

  // Fallback for SSR or when window is not available
  return stripTrailing(process.env.REACT_APP_BACKEND_URL || '');
};

export const BACKEND_URL = getBackendUrl();
export const API = `${BACKEND_URL}/api`;

export default API;
